import React, {FC, ReactNode, useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../reducers";
import LoadingContainer from "../Common/LoadingContainer";
import {usePlaceContext} from "../../services/Place/PlaceContext";
import {api} from "../../services/Api/api";
import {getSession, selectLocale} from "../../services/Session/reducer";


interface OwnProps {
    children?: ReactNode,
    menus: boolean,
    order: boolean
}

type Props = ReturnType<typeof mapStateToProps> & DispatchProp & OwnProps;

const FetchPlaces: FC<Props> = (props) => {
    const controller = new AbortController();
    const {places, updatePlaces, updateLoading} = usePlaceContext();
    const [loading, setLoading] = useState(true);

    const fetch = async () => {
        try {
            updateLoading(true);
            let response = await api.getPlaces(props.session.coordinates, {
                lang: props.locale
            });
            updatePlaces(response, props.session.coordinates);
            setLoading(false);
        } catch (err) {
            setLoading(false);
        } finally {
            updateLoading(false);
        }
    }

    const init = async () => {
        if (!places) {
            await fetch();
        } else {
            setLoading(false);
        }
    }

    const refresh = async () => {
        if (places) {
            try {
                updateLoading(true)
                let response = await api.getPlaces(props.session.coordinates, {lang: props.locale});
                updatePlaces(response, props.session.coordinates);
                setLoading(false);
            } catch (err) {
                setLoading(false);
            } finally {
                updateLoading(false);
            }
        }
    }

    useEffect(() => {
        init()
        return () => {
            controller.abort();
        };
    }, [])
    useEffect(() => {
        refresh();
    }, [props.session.coordinates, props.locale])

    if (loading) {
        return (
            <LoadingContainer/>
        )
    }

    return (
        <>
            {props.children}
        </>
    )
};

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
    locale: selectLocale(state.session)
})

const connector = connect(mapStateToProps);
export default connector(FetchPlaces);
